// AUTHENTICATION
import {
  CHECK_USER_INFO,
  LOGOUT,
  SET_USER_INFO,
  LOAD_TKN_INFO,
  CHANGE_TAB,
  SET_USER_SUBS,
} from '../constants/action-types/auth';

export function SetUserInfo(userinfo) {
  return {
    type: SET_USER_INFO,
    userinfo,
  };
}

export function SetUserSubs(subscriptions) {
  return {
    type: SET_USER_SUBS,
    subscriptions,
  };
}

export function Logout() {
  return {
    type: LOGOUT,
  };
}

export function CheckUserInfo() {
  return {
    type: CHECK_USER_INFO,
  };
}

export function LoadTknInfo(idToken, accessToken, profile) {
  return {
    type: LOAD_TKN_INFO,
    idToken,
    accessToken,
    profile,
  };
}

export function ChangeTab(tab) {
  return {
    type: CHANGE_TAB,
    tab,
  };
}
